import React, {Component} from 'react';
import PropTypes from 'prop-types';
import govmap from 'config/govmap';
import styles from './styles.module.scss';

const defaultState = {image_path: null};

class Map extends Component {
  state = defaultState;

  componentDidMount() {
    const {govmapScript} = this.addScripts();
    govmapScript.onload = () => {
      Promise.resolve()
        .then(() => window.govmap.createMap('map',
          {
            ...govmap,
            layers: ['PARCEL_ALL'],
            showXY: true,
            identifyOnClick: true,
            isEmbeddedToggle: false,
            background: '-1',
            layersMode: 1,
            zoomButtons: true,
          }))
        .then(this.getCoordinatesAndSetPosition)
    };
  }

  addScripts = () => {
    const jqueryScript = document.createElement('script');
    jqueryScript.src = 'https://code.jquery.com/jquery-3.3.1.min.js';
    jqueryScript.async = false;
    document.body.appendChild(jqueryScript);
    const govmapScript = document.createElement('script');
    govmapScript.src = 'https://www.govmap.gov.il/govmap/api/govmap.api.js';
    govmapScript.async = false;
    document.body.appendChild(govmapScript);

    return {jqueryScript, govmapScript}
  };

  getCoordinatesAndSetPosition = () => {
    window.govmap.geocode({"keyword":this.props.defaultMapPosition},window.govmap.geocodeType.FullResult)
      .then(response => {
        const {X: x, Y: y} = response.data[0];
        window.govmap.zoomToXY({ x, y, level: 8, marker: false });
        this.props.onGetImage({x, y})
      })
      .catch(e=>console.error(e))
  };

  render() {
    return (
      <div {...this.props}>
        <div id="map" className={styles.appMap} />
      </div>
    );
  }
}

Map.propTypes = {
  defaultMapPosition: PropTypes.shape({
    city: PropTypes.string,
    street: PropTypes.string,
  })
};

export default Map;
